const HIDDEN_LOA_FLAG_STATUSES = new Set(["0", "00", "1", "01"]);
const HIDDEN_LOA_STATUS_LABELS = new Set(["PENDING", "APPROVED TRN"]);

const STATUS_LABEL_VALUES = new Set([
  "CANCELLED",
  "FOR APPROVAL",
  "RETURNED BY APPROVER",
  "REJECTED",
]);

export const isStatusLoaDisplayValue = (value) => {
  const normalized = String(value || "").trim().toUpperCase();
  return STATUS_LABEL_VALUES.has(normalized);
};

export const getDisplayLoaNo = (transaction = {}, options = {}) => {
  const rawLoaNo = String(transaction?.loa_no || "").trim();
  if (!rawLoaNo) return "";

  if (options.hideRealLoaNo) {
    return isStatusLoaDisplayValue(rawLoaNo) ? rawLoaNo : "";
  }

  const transFlagStatus = String(transaction?.trans_flag_status || "").trim();
  const statusLabel = String(
    transaction?.trn_status || transaction?.trans_flag_desc || ""
  )
    .trim()
    .toUpperCase();
  if (
    (HIDDEN_LOA_FLAG_STATUSES.has(transFlagStatus) ||
      HIDDEN_LOA_STATUS_LABELS.has(statusLabel)) &&
    !isStatusLoaDisplayValue(rawLoaNo)
  ) {
    return "";
  }

  return rawLoaNo;
};

export const shouldDisplayLoaNo = (transaction = {}, options = {}) =>
  Boolean(getDisplayLoaNo(transaction, options));
